/* 🤖 this file was generated by svg-to-ts*/
export const iconMicrosoft = {
  name: 'microsoft',
  data: `
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.8684 0H0.5V11.3684H11.8684V0Z" fill="#F25022"/>
<path d="M11.8684 12.6316H0.5V24H11.8684V12.6316Z" fill="#00A4EF"/>
<path d="M24.5 0H13.1316V11.3684H24.5V0Z" fill="#7FBA00"/>
<path d="M24.5 12.6316H13.1316V24H24.5V12.6316Z" fill="#FFB900"/>
</svg>
`,
}
